import { render } from "./GoalSubHeaderSkeleton.vue?vue&type=template&id=62781536&scoped=true"
import script from "./GoalSubHeaderSkeleton.vue?vue&type=script&lang=js"
export * from "./GoalSubHeaderSkeleton.vue?vue&type=script&lang=js"

import "./GoalSubHeaderSkeleton.vue?vue&type=style&index=0&id=62781536&lang=scss&scoped=true"
import "./GoalSubHeaderSkeleton.vue?vue&type=style&index=1&id=62781536&lang=scss"
script.render = render
script.__scopeId = "data-v-62781536"

export default script